<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      v-if="ativo"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :color="item.pedido_compra_fracionada_id ? 'blue' : ''"
          v-bind="attrs"
          v-on="on"
          icon
        >
          <v-icon>mdi-alpha-f-box-outline</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-toolbar dark flat color="#042333" height="58px">
          <v-btn icon dark @click="fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title class="subtitle-1">
            {{ item.descricao_produto }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-data-table
            :items="produto"
            :headers="headers.produto"
            item-key="produto"
            hide-default-footer
            class="elevation-1 mx-4 mt-3"
          >
          </v-data-table>
          <v-row
            class="mx-1 mt-0 mb-0 pedido-fracionado"
            justify="end"
            v-if="parcelas.length == 0 || recalc"
          >
            <v-col cols="auto" class="pb-0">
              <v-text-field
                v-model="form.qtde"
                v-currency="qtde"
                label="Quantidade"
                class="quantidade"
                dense
                outlined
                disabled
                :error-messages="qtdeErrors"
                @input="$v.form.qtde.$touch()"
                @blur="$v.form.qtde.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="auto" class="pb-0">
              <v-select
                v-model="form.parcela"
                :items="selects.parcelas"
                dense
                label="Qtde. de pedidos*"
                outlined
                :error-messages="parcelasErrors"
                @input="$v.form.parcela.$touch()"
                @blur="$v.form.parcela.$touch()"
              ></v-select>
            </v-col>
            <v-col cols="3" class="pb-0">
              <v-text-field
                v-model="form.tempo"
                v-currency="number"
                dense
                label="Tempo médio entre pedidos (dias)*"
                outlined
                :error-messages="tempoErrors"
                @input="$v.form.tempo.$touch()"
                @blur="$v.form.tempo.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="pb-0">
              <v-text-field
                v-model="form.diautil"
                v-currency="number"
                dense
                label="Dias Úteis*"
                outlined
                :error-messages="diautilErrors"
                @input="$v.form.diautil.$touch()"
                @blur="$v.form.diautil.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="auto" class="pb-0">
              <v-btn
                color="white"
                height="40px"
                @click="recalc = false"
                class="mr-2"
                v-if="editado == true"
              >
                Cancelar
              </v-btn>

              <v-btn color="success" dark height="40px" @click="calcular([])">
                Calcular
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mx-1 mt-0 mb-2 pedido-fracionado" justify="end" v-else>
            <v-col cols="auto" class="mb-1"> </v-col>
            <v-col cols="auto" class="mb-1">
              <v-btn
                color="white"
                height="42px"
                @click="recalc = true"
                class="mr-2"
              >
                Re-Calcular
              </v-btn>
              <v-btn
                color="white"
                height="42px"
                @click="cardex = true"
                v-if="!cardex"
              >
                cardex
              </v-btn>
              <v-btn color="white" height="42px" @click="cardex = false" v-else>
                parcelas
              </v-btn>
              <v-btn color="white" height="42px" @click="excluir" class="ml-2">
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table
            v-show="cardex"
            :items="itens"
            :headers="headers.itens"
            height="calc(100vh - 300px)"
            item-key="id"
            hide-default-footer
            disable-pagination
            fixed-header
            class="elevation-2 mx-4 mt-0"
          >
          </v-data-table>
          <v-data-table
            v-show="!cardex"
            :items="parcelas"
            :headers="headers.parcelas"
            height="calc(100vh - 300px)"
            item-key="id"
            hide-default-footer
            disable-pagination
            fixed-header
            class="elevation-2 mx-4 mt-0"
          >
            <template v-slot:item.v_qtde_solicitada="{ item }">
              <div v-if="item.parcela != parcelas.length">
                <v-text-field
                  v-model="item.v_qtde_solicitada"
                  v-currency="qtde"
                  single-line
                  hide-details
                  @focus="$event.target.select()"
                  @blur="qtdeSolicitada(item)"
                  :rules="qtdeRules"
                  class="qtde_solicitada"
                ></v-text-field>
              </div>
              <div v-else>{{ item.v_qtde_solicitada }}</div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="pa-0 pt-2 px-4">
          <v-spacer></v-spacer>
          <v-btn color="white" @click="fechar"> Cancelar </v-btn>
          <v-btn
            color="#042333"
            class="white--text"
            @click="salvar()"
            :disabled="!editado"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  props: ["item"],
  data() {
    return {
      dialog: false,
      cardex: false,
      recalc: false,
      editado: false,
      title: "",
      qtdeRules: [],
      headers: {
        produto: [
          { text: "Saldo Inicial", value: "v_estoque", align: "center" },
          {
            text: "Tempo Resuprimento",
            value: "v_tempo_medio_ressuprimento",
            align: "center",
          },
          {
            text: "Consumo Mensal",
            value: "v_consumo_medio_mensal",
            align: "center",
          },
          {
            text: "Estoque Segurança",
            value: "v_estoque_seguranca",
            align: "center",
          },
          { text: "Ponto Pedido", value: "v_ponto_pedido", align: "center" },
          {
            text: "Estoque Máximo",
            value: "v_estoque_maximo",
            align: "center",
          },
        ],
        itens: [
          { text: "id", value: "id", align: "center" },
          { text: "data", value: "data", align: "center" },
          { text: "tipo", value: "tipo", align: "center" },
          { text: "Entrada", value: "entrada", align: "center" },
          { text: "Saida", value: "saida", align: "center" },
          { text: "Saldo", value: "saldo", align: "center" },
        ],
        parcelas: [
          { text: "Parcela", value: "parcela", align: "center" },
          { text: "Pedido", value: "idpedido" },
          { text: "Data de Emissão", value: "data_emissao", align: "center" },
          {
            text: "Saldo no dia do Pedido",
            value: "v_saldo_inicial",
            align: "center",
          },
          {
            text: "Qtde Solicitada",
            value: "v_qtde_solicitada",
            width: "140px",
            align: "center",
          },
          {
            text: "Previsão de Chegada",
            value: "data_chegada",
            align: "center",
          },
          {
            text: "Saldo Futuro (dia de chegada)",
            value: "v_saldo_futuro",
            align: "center",
          },
          {
            text: "Consumo Mensal",
            value: "v_consumo_medio_mensal",
            align: "center",
          },
          { text: "COB", value: "v_cob", align: "center" },
        ],
      },
      qtde: {
        currency: null,
        distractionFree: { hideCurrencySymbol: false },
        precision: 4,
        allowNegative: false,
        valueAsInteger: false,
        autoDecimalMode: false,
      },
      number: {
        currency: null,
        distractionFree: { hideCurrencySymbol: false },
        precision: 0,
        allowNegative: false,
        valueAsInteger: true,
        autoDecimalMode: true,
      },
    };
  },
  validations: {
    form: {
      parcela: { required },
      qtde: { required },
      tempo: { required },
      diautil: { required },
    },
  },
  computed: {
    ...mapGetters("produtoFracionado", [
      "selects",
      "produto",
      "itens",
      "parcelas",
      "form",
    ]),

    ...mapGetters("pedidoFracionado", ["ativo"]),

    parcelasErrors() {
      const errors = [];
      if (!this.$v.form.parcela.$dirty) return errors;
      !this.$v.form.parcela.required &&
        errors.push("A qtde. de pedidos é obrigatória.");
      return errors;
    },
    qtdeErrors() {
      const errors = [];
      if (!this.$v.form.qtde.$dirty) return errors;
      !this.$v.form.qtde.required && errors.push("A quantidade é obrigatória.");
      return errors;
    },
    tempoErrors() {
      const errors = [];
      if (!this.$v.form.tempo.$dirty) return errors;
      !this.$v.form.tempo.required &&
        errors.push("O tempo médio entre pedidos é obrigatório.");
      return errors;
    },
    diautilErrors() {
      const errors = [];
      if (!this.$v.form.diautil.$dirty) return errors;
      !this.$v.form.diautil.required &&
        errors.push("O dia útil é obrigatório.");
      return errors;
    },
  },
  created() {
    // this.$store.dispatch("produtoFracionado/Ativo");
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.form.qtde = this.item.qtde_pedido;
        this.form.parcela = "";
        this.form.diautil = 26;
        this.title = this.item.descricao_produto;
        this.$store.dispatch(
          "loading/addRequisicao",
          this.$store.dispatch("produtoFracionado/Itens", {
            idgrupo: this.item.grupo,
            filial: this.item.filial_compra,
            idproduto: this.item.idproduto,
            idpedido: this.item.idpedido,
          })
        );
        this.cardex = false;
      } else {
        this.editado = false;
        this.$v.$reset();
        this.$emit("fracionado");
      }
    },
  },
  methods: {
    salvar() {
      this.$store.dispatch(
        "loading/addRequisicao",
        this.$store.dispatch("produtoFracionado/Store").then(() => {
          this.editado = false;
          this.dialog = false;
        })
      );
    },
    excluir() {
      if (confirm("Deseja remover as parcelas?")) {
        this.$store
          .dispatch("produtoFracionado/Delete", {
            idgrupo: this.item.grupo,
            filial: this.item.filial_compra,
            idproduto: this.item.idproduto,
            idpedido: this.item.idpedido,
          })
          .then(() => {
            this.dialog = false;
          });
      }
    },
    calcular() {
      this.qtdeRules = [];
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this.recalc = false;
      this.$store.commit("produtoFracionado/setCalcFormParcelas", {
        qtd: parseFloat(this.form.qtde.replace(".", "").replace(",", ".")),
        par: this.form.parcela,
      });
      this.setar();
    },
    fechar() {
      if (this.editado) {
        if (confirm("Existe item a ser salvo, não salvar mesmo assim?")) {
          this.dialog = false;
        }
      } else {
        this.dialog = false;
      }
    },
    qtdeSolicitada(item) {
      this.qtdeRules = [];
      clearTimeout(this.interval);
      this.interval = setTimeout(() => {
        let q = 0;
        let p = -1;
        let s = parseFloat(
          item.v_qtde_solicitada.replace(".", "").replace(",", ".")
        );
        const qtde = parseFloat(this.form.qtde);
        var error = false;
        if (s <= 0 || s > qtde) {
          error = true;
        }
        var d1 = moment(this.parcelas[0].data_emissao, "DD/MM/YYYY");
        var d2 = moment(this.parcelas[1].data_emissao, "DD/MM/YYYY");
        this.parcelas.forEach((v) => {
          if (v.parcela < item.parcela) {
            s += v.qtde_solicitada;
          } else {
            p++;
          }
          q += v.qtde_solicitada;
        });
        q = q - s;
        let r = 0;
        if (q % p != 0) {
          r = q % p;
          q = q - r;
        }
        if (parseFloat(q / p) <= 0) {
          error = true;
        }
        if (error) {
          this.qtdeRules = [() => !error || "error:" + error];
          this.editado = false;
          return false;
        }
        this.$store.commit("produtoFracionado/setForm", {
          index: item.parcela - 1,
          value: item.v_qtde_solicitada.replace(".", "").replace(",", "."),
          tempo: d2.diff(d1, "days"),
          diautil: this.parcelas[0].diautil,
        });
        for (let i = 0; i < this.form.parcelas.length; i++) {
          if (i > item.parcela - 1) {
            this.$store.commit("produtoFracionado/setForm", {
              index: i,
              value: parseFloat(q / p + r),
            });
            r = 0;
          }
        }
        this.setar();
      }, 200);
    },
    setar() {
      this.editado = true;
      let pro = this.produto[0];
      this.$store.dispatch(
        "loading/addRequisicao",
        this.$store.dispatch("produtoFracionado/Setar", {
          pro: pro,
          tem: this.form.tempo,
          diautil: this.form.diautil,
          idpedido: this.item.idpedido,
        })
      );
    },
    flo(v) {
      if (!v) return;
      return parseFloat(v.replace(".", "").replace(",", "."));
    },
  }
};
</script>

<style>
.pedido-fracionado input {
  text-align: right !important;
}
.border-top-0 {
  border-top: 0 !important;
}

.pedido-fracionado
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 0.875rem;
  height: 39px;
}

.qtde_solicitada input {
  text-align: center !important;
  margin: 0;
  padding: 0;
  padding-left: 3px;
  margin-top: -17px;
  font-size: 15px;
}

.qtde_solicitada.error--text input {
  color: #ff5252 !important;
  caret-color: #ff5252 !important;
}
</style>
